import { useQuery } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { FolderKanban } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useQuoteBuilderApi } from '../api/client'
import type { Quote } from '../api/types'
import { projectStartQueryOptions } from './api'

/**
 * The current-quote bar's link to the project a quote started. There is no Start button: the
 * project starts on its own once the customer signs and pays (USA-1334); Start shows what is left.
 */
export function ProjectLinkAction({ quote }: { quote: Quote }) {
  const api = useQuoteBuilderApi()
  const { data } = useQuery({ ...projectStartQueryOptions(api, quote.id), enabled: quote.status === 'started' })
  const project = data?.project
  if (!project) return null
  return (
    <Button asChild size="sm" variant="outline">
      <Link aria-label="Project" params={{ projectId: project.project.uuid ?? '' }} to="/projects/$projectId">
        <FolderKanban aria-hidden="true" />
        <span className="hidden sm:inline">Project</span>
      </Link>
    </Button>
  )
}
